<template>
<div>
<b-list-group>
  <b-list-group-item v-for="con in conList" v-bind:key="con.id" v-bind:href="'#/constellations/' + con.id">{{con.name}}</b-list-group-item>
  </b-list-group>
   <b-table
      :items="conList"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive="sm"
      @row-clicked="rowClickHandler"
      striped
      outlined
      borderless
    ></b-table>
    </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import { mapState } from "vuex";

Vue.use(Vuex);
Vue.use(VueRouter);

export default {
  name: "ConstellationListPage",
  components: {
  },

  computed: {
    ...mapState([
    "utc",
    "location",
    "culture",
    "strings",
    "staticData",
  ])
  },
  watch: {
  },
  mounted() {
    this.conList = [];
    for (const [key, value] of Object.entries(this.staticData.cons)) {
      this.conList.push({id: key, name: value.name});
    }
  },
  methods: {
    layout: function() {
    },
    rowClickHandler(row) {
      this.$router.push({path: `/constellations/${row.id}`});
    }
  },
  data() {
      return {
        sortBy: 'age',
        sortDesc: false,
        fields: [
          { key: 'id', sortable: true },
          { key: 'name', sortable: true },
        ],
        conList: null,
      }
  }
};
</script>

<style>
 
</style>
